// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestId } from './Harvest';
import { harvestOperationTemplateRevisionId } from './HarvestOperationTemplateRevision';
import { harvestProtocolOperationTemplateId } from './HarvestProtocolOperationTemplate';
import { batchTypeEnum } from './BatchTypeEnum';
import { harvestOperationStatusEnum } from './HarvestOperationStatusEnum';
import { operatorId } from './Operator';
import { equipmentId } from './Equipment';
import { opKind } from './OpKind';
import { harvestBranchId } from './HarvestBranch';
import { harvestStageId } from './HarvestStage';
import { z } from 'zod';
export const harvestOperationId = (z.number());
export const harvestOperation = z.object({
    id: harvestOperationId,
    harvest_id: harvestId,
    name: z.string(),
    template_id: harvestOperationTemplateRevisionId,
    source_protocol_op_template_id: harvestProtocolOperationTemplateId.nullable(),
    depends_on: harvestOperationId.nullable(),
    depends_on_material: batchTypeEnum.nullable(),
    planned_start_at: z.date().nullable(),
    planned_duration_s: z.string().nullable(),
    status: harvestOperationStatusEnum,
    assigned_operator_id: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    depth: z.number(),
    planned_start_amount_unit: z.string().nullable(),
    planned_start_amount_value: z.string().nullable(),
    equipment_id: equipmentId.nullable(),
    data_first_modified_at: z.date().nullable(),
    data_last_modified_at: z.date().nullable(),
    op_kind: opKind,
    branch_id: harvestBranchId.nullable(),
    stage_id: harvestStageId.nullable(),
});
export const harvestOperationInitializer = z.object({
    id: harvestOperationId.optional(),
    harvest_id: harvestId,
    name: z.string(),
    template_id: harvestOperationTemplateRevisionId,
    source_protocol_op_template_id: harvestProtocolOperationTemplateId.optional().nullable(),
    depends_on: harvestOperationId.optional().nullable(),
    depends_on_material: batchTypeEnum.optional().nullable(),
    planned_start_at: z.date().optional().nullable(),
    planned_duration_s: z.string().optional().nullable(),
    status: harvestOperationStatusEnum.optional(),
    assigned_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    depth: z.number().optional(),
    planned_start_amount_unit: z.string().optional().nullable(),
    planned_start_amount_value: z.string().optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    data_first_modified_at: z.date().optional().nullable(),
    data_last_modified_at: z.date().optional().nullable(),
    op_kind: opKind.optional(),
    branch_id: harvestBranchId.optional().nullable(),
    stage_id: harvestStageId.optional().nullable(),
});
export const harvestOperationMutator = z.object({
    id: harvestOperationId.optional(),
    harvest_id: harvestId.optional(),
    name: z.string().optional(),
    template_id: harvestOperationTemplateRevisionId.optional(),
    source_protocol_op_template_id: harvestProtocolOperationTemplateId.optional().nullable(),
    depends_on: harvestOperationId.optional().nullable(),
    depends_on_material: batchTypeEnum.optional().nullable(),
    planned_start_at: z.date().optional().nullable(),
    planned_duration_s: z.string().optional().nullable(),
    status: harvestOperationStatusEnum.optional(),
    assigned_operator_id: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    depth: z.number().optional(),
    planned_start_amount_unit: z.string().optional().nullable(),
    planned_start_amount_value: z.string().optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    data_first_modified_at: z.date().optional().nullable(),
    data_last_modified_at: z.date().optional().nullable(),
    op_kind: opKind.optional(),
    branch_id: harvestBranchId.optional().nullable(),
    stage_id: harvestStageId.optional().nullable(),
});
//# sourceMappingURL=HarvestOperation.js.map